import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Cargo } from '../models/cargo';

@Injectable({
  providedIn: 'root'
})

export class CargoService {

  public readonly API = `${environment.BASE_URL}${environment.API}/cargo/`;

  constructor(
    private http: HttpClient
  ) { }

  getRegistro(id: number) {
    return this.http.post(`${this.API}registro`, {id: id});
  }

  getRegistros(params: HttpParams): any {
    return this.http.post(`${this.API}registros`, {params});
  }

  onApagar(id: number) {
    return this.http.post(`${this.API}apagar`, {id: id});
  }

  onSalvar(model: Cargo) {
    return this.http.post(`${this.API}salvar`, model);
  }

}
